module.exports = __webpack_public_path__ + "img/vertical_7_1_2.0a37168a.png";